export const SESSION_EXPIRED_STATUSES: number[] = [401, 403, 419];
